import { langStore } from "@/stores/lang-store"
import KpiCard from "@/routes/apt/[apt_code]/analysis/_components/kpi-card"
import UsageMetaItem from "./usage-meta-item"
import { leakChartStore } from "../leak/leak-chart-store"
import { UsagekpiBundle } from "./usage-kpi-const"
import { leakTypeSwitch } from "./usage-kpi-util"
import Wrapper from "@/components/wrapper"

const UsageKpiView = ({ className = "" }) => {
  const { lang } = langStore()
  const { pickUnit, usageSum, leakSum, leakRate } = leakChartStore()

  return (
    <Wrapper.shadow className={className}>
      <div
        className="
          grid grid-cols-2 items-center justify-between
          rounded-2xl
          border border-gray-200
          bg-gray-50 px-4 py-2.5
        "
      >
        <UsageMetaItem
          label={UsagekpiBundle.leakStartTime[lang]}
          value={
            pickUnit?.leakStartAt
              ? pickUnit?.leakStartAt.replace(/-/g, ".") + UsagekpiBundle.time[lang]
              : "-"
          }
        />

        <UsageMetaItem
          label={UsagekpiBundle.leakType[lang]}
          value={leakTypeSwitch(pickUnit?.leakType)[lang] ?? "-"}
        />
      </div>

      <div className="grid grid-cols-3 gap-3">
        <KpiCard
          title={UsagekpiBundle.usage[lang]}
          value={`${usageSum.toFixed(2)} m³`}
          accent="blue"
        />
        <KpiCard
          title={UsagekpiBundle.leakAmount[lang]}
          value={`${leakSum.toFixed(2)} m³`}
          accent="orange"
        />
        <KpiCard
          title={UsagekpiBundle.leakRate[lang]}
          value={`${leakRate.toFixed(2)} %`}
          accent="red"
        />
      </div>
    </Wrapper.shadow>
  )
}

export default UsageKpiView
